export const emptyStructure = {
    views: {},
    forms: {},
    previews: {},
    readouts: {},
    navigation: [],
};
//# sourceMappingURL=emptyStructure.js.map